import Axios from 'axios';
import { AccountFeatureFlag, PageableResponse } from '../models';
import { composeQuery, Query } from '../models/query';

export const getAccountFeatureFlags = async (...criteria: Query<AccountFeatureFlag>[]) => (await Axios.get<PageableResponse<AccountFeatureFlag>>('/v1/account-feature-flag', {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  params: composeQuery<AccountFeatureFlag>(...criteria),
  data: {},
})).data;
